var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "item mb-2", class: { current: _vm.isCurrent } },
    [
      _c("div", {
        staticClass: "contact",
        domProps: { textContent: _vm._s(_vm.contactLine) },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "outgoing-number",
        domProps: { textContent: _vm._s(_vm.outgoingNumberLine) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }